<template>
    <button type="button" class="appearance-none outline-none bg-none" @click="clickFav()">
        <img v-show="!isFav" class="lg:h-6 w-auto" src="@/assets/icon/ic-fav-inactive.svg" />
        <img v-show="isFav" class="lg:h-6 w-auto" src="@/assets/icon/ic-fav-active.svg" />
    </button>
</template>
<script>
// import Util from '@/helper/Utility.js';
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign'
import AuthStatusMixin from '@/mixin/AuthStatusMixin'

export default {
    name: 'ButtonFavorite',
    mixins: [AuthStatusMixin],
    inject: ['Campaign'],
    data: function () {
        return {
            isFav: false,
            campaign: null,
        };
    },
    created: function () {
        this.campaign = this.Campaign.value;
        this.isFav = this.campaign.isFavourite;
    },
    mounted: function () {
        this.AccountStore.methods.loginStatus().subscribe((status) => {
            if (status) {
                this.loadPageCommand();
            }
        })
    },
    methods: {
        //AuthStatusMixin
        onAccountInit: function () {
            // this.loadPageCommand();
        },
        clickFav: function () {
            if (this.isLoginAccount) {
                this.setFav();
            } else {
                let path = this.$route.fullPath + `?command=set-fav-true`;
                this.$router.push({
                    name: 'login',
                    query: {
                        afterLogin: path,
                    },
                });
            }
        },
        setFav: function () {
            let observable = null
            if (!this.isFav) {
                observable = BzbsCampaign.apiAddFavourite(this.campaign.id)

            } else {
                observable = BzbsCampaign.apiRemoveFavourite(this.campaign.id)
            }

            observable.subscribe({
                next: (res) => {
                    console.log(res)
                    this.isFav = !this.isFav
                },
                error: (err) => {
                    console.log(err)
                }
            })
        },

        loadPageCommand: function () {
            let command = this.$route.query.command;
            if (command == 'set-fav-true') {
                if (this.isLoginAccount && !this.isFav) {
                    this.setFav();
                }
                this.$router.replace({ 'query': null });
            }
        },
    }
}
</script>
